import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { CoreBuildingBlock } from '../../shared/building-block.decorator';
import { FeatureFlagService } from '@cudirect/shared-ui-library';
import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { WorkflowService } from '@workflow/service/workflow/workflow.service';
import { AddressService } from '@workflow/service/address/address.service';
import { LogicService } from '@workflow/service/logic/logic.service';
import { StringVariableService } from '@workflow/service/string-variable/string-variable.service';

/**
 * Text only component
 */
@CoreBuildingBlock('content')
@Component({
  selector: 'cu-content',
  templateUrl: './content.component.html'
})
export class ContentComponent extends CoreBuildingBlockControlBaseComponent {
  @ViewChild('pContentTagID', { static: true }) public pContentTagID: ElementRef;

  constructor(
    private readonly workflowService: WorkflowService,
    logicService: LogicService,
    changeDetectorRef: ChangeDetectorRef,
    stringVariableService: StringVariableService,
    addressService: AddressService,
    featureFlagService: FeatureFlagService
  ) {
    super(logicService, changeDetectorRef, stringVariableService, addressService, featureFlagService);
  }
  /** returns content */
  /** Need to be refactored */
  public get content(): string {
    const fieldId = this.field.config.id.split('$')[0];
    const cards = this.workflowService.currentPage && this.workflowService.currentPage.cards;
    const total_iterations = cards.filter((c) => c.fields.findIndex((f) => f.id.startsWith(fieldId)) > 0).length;
    const id = total_iterations > 0 && this.field.iterationId >= 0 ? ` ${this.field.iterationId + 1}` : '';
    const content = this.field.config.content ? this.field.config.content.replace(/ {{\$}}/gi, id) : this.field.data.valueStringOnly;

    if (this.pContentTagID && this.pContentTagID.nativeElement) {
      this.pContentTagID.nativeElement.innerHTML = content;
    }

    return content;
  }
}
